import { render, staticRenderFns } from "./TextListBgc.vue?vue&type=template&id=d7ffccf6&scoped=true&"
import script from "./TextListBgc.vue?vue&type=script&lang=js&"
export * from "./TextListBgc.vue?vue&type=script&lang=js&"
import style0 from "./TextListBgc.vue?vue&type=style&index=0&id=d7ffccf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ffccf6",
  null
  
)

export default component.exports